var render = function render(){var _vm=this,_c=_vm._self._c;return _c('d-container',{attrs:{"fluid":""}},[_c('d-row',[_c('main-sidebar',{attrs:{"items":_vm.sidebarItems}}),_c('d-col',{staticClass:"main-content offset-lg-2 offset-md-3 p-0",attrs:{"tag":"main","lg":"10","md":"9","sm":"12"}},[_c('main-navbar'),_vm._t("default"),_c('main-footer')],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }